// A bug in react strap disables the scrollbar after a modal is removed from the DOM. This is the hacky little fix until I find a more elegant way of handling it.

const EnableScrollingAfterModalClose = (ms?: number) => {
    setTimeout( () => {
        document.getElementsByTagName('body')[0].style.paddingRight = "0";
        document.getElementsByTagName('body')[0].style.overflow = "auto";
    }, ms ?? 500)
}

export default EnableScrollingAfterModalClose;